"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconIncomingCall.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconIncomingCall = function IconIncomingCall(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.023 6v5.008c.004.012.016.023.028.023h5.008m-5.019-.011 6.483-6.489",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.492 17.215a.3.3 0 0 1 .016.105 3.412 3.412 0 0 1-.153.97c-.375 1.214-1.386 2.523-2.582 2.874-3.015.898-6.191-.023-9-1.434a12.129 12.129 0 0 1-5.386-5.347c-1.414-2.797-2.34-5.957-1.438-8.957.356-1.188 1.676-2.196 2.895-2.567l.98-.257a.318.318 0 0 1 .383.203L7.98 5.07l1.184 3.305.027.086a.374.374 0 0 1-.125.426 4.425 4.425 0 0 1-1.27.664 7.861 7.861 0 0 1-1.671.324.367.367 0 0 0-.313.473 12.339 12.339 0 0 0 3.012 4.976 12.32 12.32 0 0 0 5 3.004.361.361 0 0 0 .457-.238c.008-.024.012-.047.016-.07a7.632 7.632 0 0 1 .328-1.672 4.26 4.26 0 0 1 .672-1.262.367.367 0 0 1 .426-.125l.086.027 3.316 1.18c.79.277 1.46.559 2.25.84.047.015.094.133.117.207Zm0 0",
    vectorEffect: "non-scaling-stroke"
  }))), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};

IconIncomingCall.displayName = "IconIncomingCall";
var _default = IconIncomingCall;
exports["default"] = _default;
//# sourceMappingURL=IconIncomingCall.js.map